import { useEffect, useRef, useState } from 'react';

/**
 * True below Tailwind's `sm` breakpoint (the app's single mobile cutoff).
 * Use for behavior that CSS alone can't express — e.g. swapping which items
 * an OverflowMenu holds on phones. Purely presentational branching should
 * keep using `sm:` utility classes instead.
 */
export function useIsMobile(query = '(max-width: 639px)'): boolean {
  const mql = useRef<MediaQueryList | null>(null);
  const [matches, setMatches] = useState(() => {
    // jsdom (vitest) has no matchMedia — treat it as desktop.
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    mql.current = window.matchMedia(query);
    return mql.current.matches;
  });

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const list = mql.current ?? window.matchMedia(query);
    mql.current = list;
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    list.addEventListener('change', handler);
    return () => list.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
